import { tabletBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
`

export const Content = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        border: 1px solid ${theme.colors.tfwBlack99};
        border-radius: 0.25rem;
        padding: 0.25rem 0.5rem;
    `,
)

export const RoomCount = styled.span`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: #282828;
    font-weight: 400;
    min-width: 1.5rem;
    text-align: center;
`

export const StyledStepper = styled.div(
    ({ theme }) => css`
        height: 1rem;
        width: 1rem;
        display: flex;
        cursor: pointer;

        &[disabled] {
            opacity: 0.3;
            cursor: default;
        }
    `,
)

export const Text = styled.span(
    ({ theme }) => css`
        font-size: 1rem;
        line-height: 1.375rem;
        font-weight: 600;
        color: #282828;
    `,
)
